export enum LayerType {
    CIRCLE = 'circle',
    LINE = 'line',
    SYMBOL = 'symbol',
    FILL = 'fill'
}
